export default class ExampleState {
	x: number = 1;
	y: number = 2;
}
